import Button from "@/src/components/ui/Button";
import { UniversityImage } from "@/src/components/ui/FallbackImages";
import { UniversityType } from "@/src/lib/universities";
import { Link } from "@/src/navigation";

const UniversityCard = ({
  img,
  university,
  description,
  route,
}: UniversityType) => {
  return (
    <div className="rounded-lg card-shadow bg-white w-full overflow-hidden">
      <div className="relative w-full h-[200px] bg-gray-50 flex items-center justify-center">
        <UniversityImage
          src={img}
          alt={`${university} campus and facilities - Study abroad with The Study Solution`}
          fill
          className="object-contain"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 379px"
        />
      </div>
      <div className="p-4">
        <div className="flex gap-2">
          {/* University Logo */}
          {/* <div className="relative size-[28px] md:size-[36px]">
            <Image
              src={getImageSrc(logo)}
              alt={`${university} official logo`}
              fill
              className="object-contain"
              sizes="(max-width: 768px) 28px, 36px"
            />
          </div> */}
          <h3 className="title text-text-secondary">{university}</h3>
        </div>
        <p className="mt-2 text-text-muted small-text truncate-2">
          {description}
        </p>
        <Link href={`/universities/${route}`}>
          <Button wide fill="transparent" leftArrow className="mt-2">
            اقرأ المزيد
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default UniversityCard;
